import { __rest } from "tslib";
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import determineIcon from './determineIcon';
import useLinkProps from './useLinkProps';
import getComponent from './getComponent';
import { Spinner } from '../Spinner';
const BaseButton = (props, ref) => {
    const { variant, to, inNewTab = false, className, iconStart, iconEnd, children, component, loading, isComplete, href, disabled, type = 'button' } = props, otherProps = __rest(props, ["variant", "to", "inNewTab", "className", "iconStart", "iconEnd", "children", "component", "loading", "isComplete", "href", "disabled", "type"]);
    const combinedClassNames = clsx(className, 'kal-btn', variant, disabled && 'kal-btn--disabled', loading && 'kal-loading');
    const loadingRoundel = (React.createElement("div", { className: clsx('kal-btn kal-loading-btn', variant) },
        React.createElement(Spinner, null)));
    const icon = determineIcon(loading, isComplete, iconStart);
    const ButtonComponent = getComponent(component, to, href);
    const linkProps = useLinkProps(href, to, inNewTab);
    // by default any button rendered will have type "submit", which causes
    // the submission of any form. Usually we don't want this!
    // See https://stackoverflow.com/a/31644856
    const buttonType = ButtonComponent === 'button' ? type : undefined;
    return (React.createElement(ButtonComponent, Object.assign({ className: combinedClassNames, disabled: disabled, type: buttonType, ref: ref }, linkProps, otherProps),
        variant && loadingRoundel,
        icon,
        children,
        iconEnd));
};
export default forwardRef(BaseButton);
//# sourceMappingURL=BaseButton.js.map